// hooks/useToggleAutoBilling.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentApis } from '../api/paymentApi';

export const useToggleAutoBilling = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (enable: boolean) => paymentApis.toggleAutoBilling(enable),
    onSuccess: (data) => {
      console.log('Auto billing updated:', data);
      // ✅ update cached overview data without re-fetch
      queryClient.setQueryData(['resident', 'dashboard', 'overview'], (prev: any) => {
        console.log('inside toggle before updataing local cache', prev)
        if (!prev) return prev;
        console.log('previous', prev.isAutoBillingEnabled)
        return {
          ...prev,
          isAutoBillingEnabled: !prev.isAutoBillingEnabled,
        };
      });

      // ✅ update cached payment details without re-fetch
      queryClient.setQueryData(['residentPaymentDetails'], (prev: any) => {
        if (!prev) return prev;
        return {
          ...prev,
          isAutoBillingEnabled: !prev.isAutoBillingEnabled,
        };
      });
    },
    onError: (error) => {
      console.error('Failed to toggle auto billing:', error);
    },
  });
};
